import React from "react";
import { FilterType, FilterCounts } from "../../Listing/filters";
import styles from "./Filter.module.scss";
import GetText from "../../../i18n/GetText";
import sortBy from "lodash.sortby";
import Text from "../../Text/Text";
import Checkbox from "../../../components/Inputs/Checkbox/Checkbox";

const Filter = ({
  titleId,
  filterData,
  filterCounts,
  isSelected,
  setSelected,
  sortFn = filterData => sortBy(filterData, f => f.name),
  filterType = "exclusive"
}: FilterData) => {
  const sortedFilterData = sortFn(filterData);

  return (
    <div className={styles.filterContainer}>
      <Text variant="filterHeading">
        <GetText id={titleId} />
      </Text>
      <ul className={styles.list}>
        {sortedFilterData.map((filter: FilterType) => (
          <li key={filter._id}>
            <Checkbox
              id={`checkbox-${filter._id}`}
              label={
                <Text variant="filter">
                  <GetText id={filter.name} />
                  {filterType === "exclusive" &&
                    ` (${filterCounts[filter._id] || 0})`}
                </Text>
              }
              value={filter._id}
              onChange={e =>
                setSelected({ [filter._id]: e.currentTarget.checked })
              }
              checked={isSelected(filter)}
              disabled={
                filterType === "exclusive"
                  ? !filterCounts[filter._id] && !isSelected(filter)
                  : false
              }
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Filter;

interface FilterData {
  titleId: string;
  filterData: FilterType[];
  filterCounts: FilterCounts;
  isSelected: (filter: FilterType) => boolean;
  setSelected: (selection: Record<string, boolean>) => void;
  sortFn?: (data: FilterType[]) => FilterType[];
  filterType?: "exclusive" | "inclusive";
}
